import { selectedPartnerProductOrderCartItemsState } from "@/atoms/item/selected-partner-product-order-cart-items-state";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { ItemDetailLineDto } from "../../types/dto/item-detail-line-dto";
import { PartnerProductOrderCartBody } from "../body/PartnerProductOrderCartBody";
import { PartnerProductOrderCartEmptyBody } from "../body/PartnerProductOrderCartEmptyBody";
import { PartnerProductOrderCartFooter } from "../footer/PartnerProductOrderCartFooter";
import { PartnerProductOrderCartHeader } from "../header/PartnerProductOrderCartHeader";

// 오른쪽 카트 패널

export const PartnerProductOrderCartPanel = () => {
  const [cartItems, setCartItems] = useRecoilState(
    selectedPartnerProductOrderCartItemsState
  );
  const [checkedCartItems, setCheckedCartItems] = useState<ItemDetailLineDto[]>(
    []
  );

  // localStorage에서 장바구니 데이터 불러오기
  useEffect(() => {
    const savedCartItems = localStorage.getItem("cartItems");
    if (savedCartItems) {
      setCartItems(JSON.parse(savedCartItems));
    }
  }, []);

  // cartItems가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const isEmpty = cartItems.length === 0;

  const handleSelectAll = () => {
    if (checkedCartItems.length === cartItems.length) {
      setCheckedCartItems([]);
    } else {
      setCheckedCartItems(cartItems);
    }
  };

  const handleDeleteSelected = () => {
    setCartItems(cartItems.filter((item) => !checkedCartItems.includes(item)));
    setCheckedCartItems([]);
  };

  const handleCheckItem = (line: ItemDetailLineDto) => {
    if (
      checkedCartItems.some(
        (checkedItem) => checkedItem.childItem.id === line.childItem.id
      )
    ) {
      setCheckedCartItems(
        checkedCartItems.filter(
          (checkedItem) => checkedItem.childItem.id !== line.childItem.id
        )
      );
    } else {
      setCheckedCartItems([...checkedCartItems, line]);
    }
  };

  return (
    <div className="w-[360px] h-[944px] bg-primary-white border-l-[1px] border-semantic-divider flex flex-col">
      <PartnerProductOrderCartHeader
        handleSelectAll={handleSelectAll}
        handleDeleteSelected={handleDeleteSelected}
        isAllSelected={checkedCartItems.length === cartItems.length}
        hasCheckedItems={checkedCartItems.length > 0}
      />
      <div className="flex-grow">
        {isEmpty ? (
          <PartnerProductOrderCartEmptyBody />
        ) : (
          <PartnerProductOrderCartBody
            checkedCartItems={checkedCartItems}
            handleCheckItem={handleCheckItem}
          />
        )}
      </div>
      <PartnerProductOrderCartFooter />
    </div>
  );
};
